import { useEffect } from 'react';

import { useSetTeamsConfigActions } from '../../store/main';
import { type TeamsProductConfig } from '../../types';

export const useSetTeamsProductConfig = (teamsProductConfig: TeamsProductConfig): void => {
	const { setTeamsProductConfig } = useSetTeamsConfigActions();

	useEffect(() => {
		setTeamsProductConfig(teamsProductConfig);
	}, [setTeamsProductConfig, teamsProductConfig]);
};
